export class ResultInfo {
    public Status: ResultInfoStatus;
    public Message: string;
    public NewRecordId: number;
}

export enum ResultInfoStatus {
    OK = 0,
    ERR = 1,
    Warning = 2
}